import { identity } from 'ramda';
import { createSelector } from 'reselect';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { manualLinks } from './constants';

export const getAvailableHelpLinks = createSelector(identity, (state) => {
	const baseLinks = manualLinks.filter((link) => link.type === 'base' && hasPermissionByIds(state)(link.acl));
	const additionalLinks = manualLinks.filter(
		(link) => link.type === 'additional' && hasPermissionByIds(state)(link.acl),
	);
	return { baseLinks, additionalLinks };
});
